import { getProductQuantityOfStockHintSetting } from '../../../utils/merchantData';

const STOCK_REMINDER_NUM = 10;
const FK_PREORDER_LIMIT = 'preorder_limit';

class VariationStockInfoModel {
  constructor(data) {
    this.data = data;
  }
  get hasPreorderFk() {
    return window.mainConfig.merchantData.rollout_keys.includes(
      FK_PREORDER_LIMIT,
    );
  }
  get unlimitedStock() {
    const {
      unlimited_quantity,
      out_of_stock_orderable,
      is_preorder,
      preorder_limit,
    } = this.data;

    if (unlimited_quantity) {
      return true;
    }

    if (this.hasPreorderFk && is_preorder && preorder_limit === -1) {
      return true;
    }
    if (!this.hasPreorderFk && out_of_stock_orderable) {
      return true;
    }

    return false;
  }
  get leftQuantity() {
    const { left_items_quantity, is_preorder, preorder_limit } = this.data;

    if (this.hasPreorderFk && is_preorder && preorder_limit > 0) {
      return left_items_quantity + preorder_limit;
    }

    return left_items_quantity;
  }
  computedQuantityOfStockHintText(selectedValue) {
    const {
      cart_quantity,
      unlimited_quantity,
      out_of_stock_orderable,
      quantity,
    } = this.data;

    if (
      unlimited_quantity ||
      (!this.hasPreorderFk && out_of_stock_orderable) ||
      !getProductQuantityOfStockHintSetting() ||
      quantity <= 0
    ) {
      return '';
    }

    const stockNum = Math.max(quantity - cart_quantity - selectedValue, 0);
    if (stockNum <= STOCK_REMINDER_NUM) {
      return window.shopline.i18next.t('product quantity of stock hint', {
        ns: 'translation',
        n: stockNum,
      });
    }
    return '';
  }

  checkStock(needValue) {
    return this.unlimitedStock || needValue <= this.leftQuantity;
  }
}

export default VariationStockInfoModel;
